exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".structure.new-comment {\n  margin-top: 10px;\n  margin-bottom: 20px;\n  margin-left: 35px; }\n\n.structure.answer {\n  background-color: #f9f9f9; }\n\n.flex-container.new-comment-btn {\n  width: 100%; }\n  .flex-container.new-comment-btn .flex-item {\n    width: 100%; }\n    .flex-container.new-comment-btn .flex-item a {\n      text-transform: uppercase;\n      color: #c7c8ca;\n      width: 100%;\n      display: block; }\n      .flex-container.new-comment-btn .flex-item a:hover {\n        background-color: #eeefef;\n        color: #626b6f; }\n\nhr {\n  border-bottom: 1px solid #c7c8ca; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/common/review/review.component.scss
// module id = ../../../../../src/app/common/review/review.component.scss
// module chunks = main